import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { fetchRates, resetFxRates } from '../states/rates/actions';
import { TYPE_IFT, TYPE_CHAPS } from '../config';
import { getRates, getRatesError, isRatesApiInProgress, showLiveRate } from '../states/rates/selectors';

const mapState = (state) => ({
	fxRates: getRates(state),
	fxRatesError: getRatesError(state),
	isRatesApiInProgress: isRatesApiInProgress(state),
	showLiveRate: showLiveRate(state),
});

const mapDispatch = (dispatch) => ({
	fetchRates: (payment, type) => dispatch(fetchRates(payment, type)),
	resetFxRates: () => dispatch(resetFxRates()),
});

export const getFxValidityDuration = (payload) => get(payload, 'fx.validity_duration');

export default (WrappedComponent) => {
	const withFxRates = class extends Component {
		constructor(props) {
			super(props);
			this.handleFetchRates = this.handleFetchRates.bind(this);
		}

		componentDidMount() {
			this.handleFetchRates();
		}

		componentWillUnmount() {
			const { resetFxRates } = this.props;
			resetFxRates();
		}

		handleFetchRates(isFinalApproval = false) {
			const {
				toAuthorise: { payments, type, final_approval },
				fetchRates,
				initialiseCounter,
				isSameCurrency = false,
				fxRates,
			} = this.props;
			if ([TYPE_IFT, TYPE_CHAPS].includes(type)) {
				payments.forEach((singlePayment) => {
					const rates = fxRates[singlePayment.id];
					const payment = {
						...singlePayment,
						value_date: get(rates, 'details.0.value_date', singlePayment.value_date),
						final_approval: final_approval || isFinalApproval,
					};
					fetchRates(payment, type).then(({ payload = {} }) => {
						if (!isSameCurrency) {
							const fxValidityDuration = getFxValidityDuration(payload);
							if (fxValidityDuration) initialiseCounter(fxValidityDuration);
						}
					});
				});
			}
		}
		render() {
			const { fetchRates, fxRatesError, ...otherProps } = this.props;
			return <WrappedComponent {...otherProps} fetchFxRates={this.handleFetchRates} ratesError={fxRatesError} />;
		}
	};

	withFxRates.displayName = `withFxRates(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
	withFxRates.defaultProps = {
		initialiseCounter: () => {},
	};

	withFxRates.propTypes = {
		toAuthorise: PropTypes.shape({}).isRequired,
		fxRates: PropTypes.shape({}).isRequired,
		fxRatesError: PropTypes.shape({ message: PropTypes.string.isRequired }).isRequired,
		fetchRates: PropTypes.func.isRequired,
		resetFxRates: PropTypes.func.isRequired,
		initialiseCounter: PropTypes.func,
		isRatesApiInProgress: PropTypes.bool.isRequired,
		isPreBookedPayment: PropTypes.bool.isRequired,
		showLiveRate: PropTypes.bool.isRequired,
	};

	return connect(mapState, mapDispatch)(withFxRates);
};
